// elements
import Button from 'semantic-ui-react/dist/es/elements/Button';
import Icon from 'semantic-ui-react/dist/es/elements/Icon';
import Image from 'semantic-ui-react/dist/es/elements/Image';
import Input from 'semantic-ui-react/dist/es/elements/Input';
import Label from 'semantic-ui-react/dist/es/elements/Label';
import Header from 'semantic-ui-react/dist/es/elements/Header';
import Loader from 'semantic-ui-react/dist/es/elements/Loader';
import Segment from 'semantic-ui-react/dist/es/elements/Segment';

// collections
import Form from 'semantic-ui-react/dist/es/collections/Form';
import Menu from 'semantic-ui-react/dist/es/collections/Menu';
import Message from 'semantic-ui-react/dist/es/collections/Message';
import Table from 'semantic-ui-react/dist/es/collections/Table';
import Grid from 'semantic-ui-react/dist/es/collections/Grid';
import GridRow from 'semantic-ui-react/dist/es/collections/Grid/GridRow';
import GridColumn from 'semantic-ui-react/dist/es/collections/Grid/GridColumn';

// modules
import Checkbox from 'semantic-ui-react/dist/es/modules/Checkbox';
import Dropdown from 'semantic-ui-react/dist/es/modules/Dropdown';
import Modal from 'semantic-ui-react/dist/es/modules/Modal';
import Dimmer from 'semantic-ui-react/dist/es/modules/Dimmer';
import Popup from 'semantic-ui-react/dist/es/modules/Popup';

// addons
import Select from 'semantic-ui-react/dist/es/addons/Select';

// views
import Card from 'semantic-ui-react/dist/es/views/Card';

import {
  DropdownItemProps,
  CheckboxProps,
  InputProps,
  MenuItemProps,
  ModalProps,
  TextAreaProps,
  FormFieldProps,
  SelectProps,
  SemanticICONS,
} from 'semantic-ui-react/index.d';

Grid.GridRow = GridRow;
Grid.GridColumn = GridColumn;

export {
  Button,
  Dropdown,
  Icon,
  Input,
  Modal,
  Label,
  Table,
  Checkbox,
  Form,
  Menu,
  Image,
  Message,
  Grid,
  Card,
  Header,
  Select,
  Dimmer,
  Loader,
  Segment,
  GridRow,
  Popup,
};
export type {
  DropdownItemProps,
  CheckboxProps,
  InputProps,
  MenuItemProps,
  ModalProps,
  TextAreaProps,
  FormFieldProps,
  SelectProps,
  SemanticICONS,
};
